import React from "react"
import styled from "styled-components"
import media from "styled-media-query"

const WelcomeDescription = () => {
  return (
    <>
      <h1>{`Unlimited Acts, Intervals & Calculated Times`}</h1>
      <Description>
        Show Stop Watch was created one evening while writing a show report and
        wishing everything would work its self out, well now it does! Its been
        developed by stage managers for anyone in the entertainment industry
        needing to time performances. The more we thought about it and asked for
        feedback the more features were created. We have tried to make it as
        versatile as we can to be used on any show no matter what the demands.
        We think we have got it to be able to adapt to most performances however
        we would love to hear what you think of it!
      </Description>
    </>
  )
}

export default WelcomeDescription

const Description = styled.p`
  margin: 3rem 8rem;
  color: white;
  text-align: center;
  font-weight: 300;
  /* border: 1px solid red; */

  ${media.lessThan("medium")`
  padding:1em;
  margin:1em;
  padding-bottom:0;
  `}
`
